var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('img',{staticStyle:{"width":"30px"},attrs:{"alt":"online","src":"/web/img/online-50.png"}}):_c('img',{staticStyle:{"width":"30px"},attrs:{"alt":"offline","src":"/web/img/offline-50.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }